import { useStateStore } from '$tablet-app/src/app/stores/useStateStore';
import { create } from 'zustand';
import { getNextView } from './functions';
import { MealPreferencesDialogState } from './types';

export const useMealPreferenceDialogState = create<MealPreferencesDialogState>(
  (set) => ({
    visible: false,
    view: 'main',
    preferences: {},
    draft_preferences: {},

    async show() {
      const preferences = await useStateStore
        .getState()
        .getUserMealPreferences();

      set({
        visible: true,
        preferences,
        draft_preferences: preferences,
      });
    },

    openPreferenceView(view) {
      set({ view });
    },

    goToMain() {
      set((state) => ({
        /** Return to main view */
        view: 'main',
        /** Reset the draft preferences to the current preferences */
        draft_preferences: { ...state.preferences },
      }));
    },

    updatePreference(preferences) {
      set((state) => ({
        draft_preferences: { ...state.draft_preferences, ...preferences },
      }));
    },

    cancelEditingPreference() {
      set((state) => ({
        view: 'main',
        draft_preferences: { ...state.preferences },
      }));
    },

    submitPreference() {
      set((state) => ({
        /** Return to main view */
        view: getNextView(state),
        /** Update current preferences with draft preferences */
        preferences: { ...state.draft_preferences },
      }));
    },

    closePreferencesDialog() {
      set({
        view: 'main',
        visible: false,
        preferences: {},
        draft_preferences: {},
      });
    },
  })
);

export const useOpenPreferenceView = () =>
  useMealPreferenceDialogState((state) => state.openPreferenceView);
